import { useEffect, useState } from "react";

export const INTERNAL_FEATURES_KEY = "internal_features_enabled";

export const useInternalFeatures = () => {
    const [enabled, setEnabledInner] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(INTERNAL_FEATURES_KEY);
        setEnabledInner(stored === "true");
    }, []);

    const setEnabled = (value: boolean) => {
        localStorage.setItem(INTERNAL_FEATURES_KEY, value.toString());
        setEnabledInner(value);
    };

    return {
        enabled,
        setEnabled,
    };
};
